import { render, staticRenderFns } from "./employPlatform.vue?vue&type=template&id=7739c2a2&scoped=true&"
import script from "./employPlatform.vue?vue&type=script&lang=js&"
export * from "./employPlatform.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/common/nav.less?vue&type=style&index=0&id=7739c2a2&scoped=true&lang=less&"
import style1 from "../../../assets/css/common/operating.less?vue&type=style&index=1&id=7739c2a2&scoped=true&lang=less&"
import style2 from "../../../assets/css/common/table.less?vue&type=style&index=2&id=7739c2a2&scoped=true&lang=less&"
import style3 from "../../../assets/css/common/card.less?vue&type=style&index=3&id=7739c2a2&scoped=true&lang=less&"
import style4 from "./employPlatform.vue?vue&type=style&index=4&id=7739c2a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7739c2a2",
  null
  
)

export default component.exports